module.exports = __webpack_public_path__ + "static/uniplaces-dc4db432c468fcd42bcfeec7cb16177d.png";